import React from "react";
import { useNavigate } from "react-router-dom";
import { LandingPage } from "../../../pages/LandingPage";
import { LegalDocumentsDialog } from "./LegalDocumentsDialog";

/** /privacy-policy: the home page with the Privacy Policy open on top. Closing it
 *  leaves the visitor on the home page. Keeps old links (incl. the .com redirect) working. */
export const LegalDocumentsPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <>
      <LandingPage />
      <LegalDocumentsDialog open initialTab="privacy" onClose={() => navigate("/")} />
    </>
  );
};
